<div class="page-banner-area  margintop">
    <div class="container">
        <div class="page-banner-content">
            <h2>Event Details</h2>


        </div>
    </div>
</div>

<div class="event-details-area ptb-100" *ngIf="eventDetails">
    <div class="container">
        <div class="event-details">

            <div class="row  mt-4  custom-flex-direction">
                <div class="col-lg-6 col-md-6 col-12 ">
                    <div class="event-details-image  details-section">
                        <img [src]="imgURL + eventDetails.image" alt="event image"
                            *ngIf="eventDetails.image; else noImage">
                        <ng-template #noImage>
                            <img src="assets/images/404.png" alt="default image">
                        </ng-template>
                    </div>

                    <div class="col-md-12 image-attendees-section" *ngIf="attendeesDetails && attendeesDetails.length > 0 && confirmedAttendeesDetails.length > 0">
                        <h3 class="widget-title">Confirmed Attendees</h3>
                        <ul class="small-font">
                            <li *ngFor="let attendee of attendeesDetails">
                                <ng-container *ngIf="confirmedAttendeesDetails.includes('name') && confirmedAttendeesDetails.includes('company') && confirmedAttendeesDetails.includes('title'); else checkTwoFields">
                                    {{ attendee.name }} - {{ attendee.company }} - {{ attendee.title }}
                                </ng-container>

                                <ng-template #checkTwoFields>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('company') && confirmedAttendeesDetails.includes('title'); else checkNameTitleOrNameCompany">
                                        {{ attendee.company }} - {{ attendee.title }}
                                    </ng-container>
                                </ng-template>

                                <ng-template #checkNameTitleOrNameCompany>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('name') && confirmedAttendeesDetails.includes('title'); else checkNameCompanyOrSingle">
                                        {{ attendee.name }} - {{ attendee.title }}
                                    </ng-container>
                                </ng-template>

                                <ng-template #checkNameCompanyOrSingle>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('name') && confirmedAttendeesDetails.includes('company'); else checkSingleFields">
                                        {{ attendee.name }} - {{ attendee.company }}
                                    </ng-container>
                                </ng-template>

                                <ng-template #checkSingleFields>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('company')">
                                        {{ attendee.company }}
                                    </ng-container>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('name')">
                                        {{ attendee.name }}
                                    </ng-container>
                                    <ng-container *ngIf="confirmedAttendeesDetails.includes('title')">
                                        {{ attendee.title }}
                                    </ng-container>
                                </ng-template>
                            </li>
                        </ul>
                    </div>


                </div>
                <div class="col-lg-6 col-md-6 col-12">
                    <aside class="widget-area m-0" id="secondary">
                        <div class="event-details-header ">
                            <h3>{{ eventDetails.name }}</h3>
                        </div>
                        <div class="widget widget_event_details">
                            <h3 class="widget-title">Event Schedule</h3>
                            <div class="icon_font"><i class='bx bx-calendar'></i> {{eventDetails?.event_start_datetime |
                                date:dateTimeFormat}} - {{eventDetails?.event_end_datetime | date:dateTimeFormat}}</div>
                        </div>
                        <div class="widget widget_event_details vmtop">
                            <h3 class="widget-title">Venue</h3>
                            <ul>
                                <li> <span *ngIf="eventDetails.address1">{{ eventDetails.address1 }}</span>
                                    <span *ngIf="eventDetails.address2">, {{ eventDetails.address2 }}</span>
                                    <span *ngIf="eventDetails.city">, {{ eventDetails.city }}</span>
                                    <span *ngIf="eventDetails.state">, {{ eventDetails.state }}</span>
                                    <span *ngIf="eventDetails.zipcode">, {{ eventDetails.zipcode }}</span>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="eventDetails?.description" class="widget widget_event_details">
                            <h3 class="widget-title">Roundtable Topics</h3>
                            <div class="widgetdesc" [innerHTML]="eventDetails.description"></div>
                        </div>

                    </aside>
                </div>


            </div>
            <!-- <div class="row">
               

            </div> -->
        </div>
    </div>
</div>
<div class="loader" *ngIf="loader">
    <div id="loading"></div>
</div>